import { useCallback } from 'react';
import { type MapMouseEvent } from 'react-map-gl/mapbox';

import { type HandledMapMouseEvent } from '@/types';
import { SLOW_SECTION_LAYER, STATION_LAYER, ZOOM_9 } from '@/utils/constants/map';
import {
  SEARCH_PARAM_SLOW_SECTION_ID,
  SEARCH_PARAM_SLOW_SECTIONS,
  SEARCH_PARAM_STATION_ID,
  SEARCH_PARAM_STATIONS,
} from '@/utils/constants/queries';

interface UseMapEventsProps {
  updateSearchParams: (type: string, id: string, paramsToShow: string) => void;
}

const useMapEvents = ({ updateSearchParams }: UseMapEventsProps) => {
  const selectMapMarker = useCallback(
    (event: MapMouseEvent) => {
      if ((event as unknown as HandledMapMouseEvent).originalEvent?.handled) {
        return;
      }

      const feature = event.features?.[0];

      if (!feature?.properties || !feature.layer) {
        return;
      }

      const { properties, layer } = feature;

      switch (layer.id) {
        case STATION_LAYER:
          if (event.target.getZoom() < ZOOM_9) {
            break;
          }

          updateSearchParams(SEARCH_PARAM_STATION_ID, properties.id, SEARCH_PARAM_STATIONS);
          break;

        case SLOW_SECTION_LAYER:
          updateSearchParams(
            SEARCH_PARAM_SLOW_SECTION_ID,
            properties.id,
            SEARCH_PARAM_SLOW_SECTIONS
          );
          break;

        default:
          break;
      }
    },
    [updateSearchParams]
  );

  return { selectMapMarker };
};

export default useMapEvents;
